import { render, staticRenderFns } from "./TeacherAI.vue?vue&type=template&id=9f7e9c58"
import script from "./TeacherAI.vue?vue&type=script&lang=js"
export * from "./TeacherAI.vue?vue&type=script&lang=js"
import style0 from "./TeacherAI.vue?vue&type=style&index=0&id=9f7e9c58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports